import React, { useState } from 'react';
import {PRIMARY_COLOR} from "../contants/Colors";

/**
 * Optional customer info capture shown at the bottom of every feedback page.
 * Fields: name, phone, email — all optional.
 * Uses a catchy phrase to encourage sign-up for offers.
 */
export default function CustomerCaptureForm({ branding, onChange }) {
  const [expanded, setExpanded] = useState(false);
  const [info, setInfo] = useState({ name: '', phone: '', email: '' });

  const primary = branding?.primaryColor || PRIMARY_COLOR;
  const buttonText = branding?.buttonTextColor || '#ffffff';

  const handleChange = (field, value) => {
    const updated = { ...info, [field]: value };
    setInfo(updated);
    onChange(updated);
  };

  return (
    <div style={{
      marginTop: 20,
        marginBottom: 20,
      border: `1.5px dashed ${primary}`,
      borderRadius: 12,
      overflow: 'hidden',
      background: primary + '08',
    }}>
      {!expanded ? (
        <button
          type="button"
          onClick={() => setExpanded(true)}
          style={{
            width: '100%', background: 'none', border: 'none',
            padding: '14px 18px', cursor: 'pointer', textAlign: 'left',
            display: 'flex', alignItems: 'center', gap: 12,
          }}
        >
          <span style={{ fontSize: 22 }}>🎁</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: primary }}>
              Want exclusive offers & rewards? Click here
            </div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
              Leave your contact - be the first to hear about deals just for you
            </div>
          </div>
          {/*<span style={{ fontSize: 11, color: primary, fontWeight: 600 }}>Add details →</span>*/}
        </button>
      ) : (
        <div style={{ padding: '14px 16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
            <span style={{ fontSize: 20 }}>🎁</span>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: primary }}>
                Unlock exclusive offers & be rewarded!
              </div>
              <div style={{ fontSize: 11, color: '#64748b', marginTop: 1 }}>
                All fields are optional — we'll never spam you
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
            <input
              style={{
                width: '100%', padding: '9px 12px', borderRadius: 8,
                border: '1px solid #e2e8f0', fontSize: 13, outline: 'none',
                fontFamily: 'inherit', background: '#fff',
              }}
              placeholder="Your name (optional)"
              value={info.name}
              onChange={e => handleChange('name', e.target.value)}
            />
            <input
              style={{
                width: '100%', padding: '9px 12px', borderRadius: 8,
                border: '1px solid #e2e8f0', fontSize: 13, outline: 'none',
                fontFamily: 'inherit', background: '#fff',
              }}
              placeholder="Phone number (optional)"
              type="tel"
              value={info.phone}
              onChange={e => handleChange('phone', e.target.value)}
            />
            <input
              style={{
                width: '100%', padding: '9px 12px', borderRadius: 8,
                border: '1px solid #e2e8f0', fontSize: 13, outline: 'none',
                fontFamily: 'inherit', background: '#fff',
              }}
              placeholder="Email address (optional)"
              type="email"
              value={info.email}
              onChange={e => handleChange('email', e.target.value)}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
            <button
              type="button"
              onClick={() => { setExpanded(false); setInfo({ name:'', phone:'', email:'' }); onChange({}); }}
              style={{ fontSize: 11, color: '#94a3b8', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              No thanks
            </button>
            <div style={{
              fontSize: 11, color: '#94a3b8',
              display: 'flex', alignItems: 'center', gap: 4,
            }}>
              🔒 Your info is safe with us
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
